import { styled } from '@stitches/react'

export const Container = styled('div', {
  minWidth: 360,
  width: '100vw',
  minHeight: '100vh',

  display: 'grid',
  gridTemplateRows: '1fr',
  gridTemplateColumns: '1fr',
  placeItems: 'center',
  paddingTop: 79,

  button: {
    width: '100%',
  },

  footer: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
  },
})
